export default {
  API_ENDPOINT: "https://shielded-hollows-75290.herokuapp.com",
  TOKEN_KEY: "dinner-client-auth-token"
};
